<div class="wetter_content_container">
  <h3>Videotext</h3>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Überschrift</h3>
    <p>{{spezialwetter.videotext.ueberschrift}}</p>
  </section>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Erster Absatz</h3>
    <p>{{spezialwetter.videotext.ersterAbsatz}}</p>
  </section>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Zweiter Absatz</h3>
    <p>{{spezialwetter.videotext.zweiterAbsatz}}</p>
  </section>
</div>
